import { render } from "./OrderEditorForm.vue?vue&type=template&id=4fd4892c&scoped=true"
import script from "./OrderEditorForm.vue?vue&type=script&lang=js"
export * from "./OrderEditorForm.vue?vue&type=script&lang=js"

import "./OrderEditorForm.vue?vue&type=style&index=0&id=4fd4892c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fd4892c"]])

export default __exports__